import { render, staticRenderFns } from "./expoLatestBooth.vue?vue&type=template&id=645f273d&scoped=true"
import script from "./expoLatestBooth.vue?vue&type=script&lang=js"
export * from "./expoLatestBooth.vue?vue&type=script&lang=js"
import style0 from "./expoLatestBooth.vue?vue&type=style&index=0&id=645f273d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645f273d",
  null
  
)

export default component.exports